module.exports = __webpack_public_path__ + "static/media/03 product @1x.abc9634b.jpg";